import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import SessionManager from '../../components/ui/SessionManager';
import SmartExpiryRadar from '../../components/ui/SmartExpiryRadar';
import ModuleCard from './components/ModuleCard';
import QuickStatsBar from './components/QuickStatsBar';
import RecentActivityFeed from './components/RecentActivityFeed';
import SystemStatusIndicator from './components/SystemStatusIndicator';
import KeyboardShortcutsPanel from './components/KeyboardShortcutsPanel';




const MainOperationsDashboard = () => {
  const [quickStats, setQuickStats] = useState([]);
  const [moduleData, setModuleData] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);

  useEffect(() => {
    setQuickStats([
      {
        label: 'Total Properties',
        value: '247',
        icon: 'Building2',
        color: 'var(--color-accent)',
        change: { value: '+12 this month', trend: 'up' }
      },
      {
        label: 'Vacant Units',
        value: '18',
        icon: 'Home',
        color: 'var(--color-warning)',
        change: { value: '-3 from last week', trend: 'down' }
      },
      {
        label: 'Open Maintenance',
        value: '34',
        icon: 'Wrench',
        color: 'var(--color-error)',
        change: { value: '+5 today', trend: 'up' }
      },
      {
        label: 'Renewals Due (30d)',
        value: '23',
        icon: 'Calendar',
        color: 'var(--color-success)',
        change: { value: '8 this week', trend: 'up' }
      }
    ]);

    setModuleData([
      {
        title: 'Properties',
        icon: 'Building2',
        iconColor: 'var(--color-accent)',
        route: '/properties-management-screen',
        stats: [
          { label: 'Total Properties', value: '247' },
          { label: 'Occupied', value: '229' },
          { label: 'Vacant', value: '18' }
        ],
        alerts: [
          { text: '3 properties need inspection', color: 'var(--color-warning)' }
        ]
      },
      {
        title: 'Certificates',
        icon: 'ShieldCheck',
        iconColor: 'var(--color-warning)',
        route: '/smart-certificate-expiry-management',
        stats: [
          { label: 'Total Certificates', value: '1,235' },
          { label: 'Valid', value: '1,187' },
          { label: 'Expiring Soon', value: '35' }
        ],
        alerts: [
          { text: '13 certificates expired', color: 'var(--color-error)' },
          { text: '22 expiring within 14 days', color: 'var(--color-warning)' }
        ]
      },
      {
        title: 'Maintenance',
        icon: 'Wrench',
        iconColor: 'var(--color-error)',
        route: '/maintenance-kanban-workflow-board',
        stats: [
          { label: 'Open Jobs', value: '34' },
          { label: 'In Progress', value: '12' },
          { label: 'Awaiting Invoice', value: '8' }
        ],
        alerts: [
          { text: '5 urgent jobs pending', color: 'var(--color-error)' }
        ]
      },
      {
        title: 'Tenancies',
        icon: 'Users',
        iconColor: 'var(--color-success)',
        route: '/properties-management-screen',
        stats: [
          { label: 'Active Tenancies', value: '229' },
          { label: 'Renewals (30d)', value: '23' },
          { label: 'Renewals (14d)', value: '9' }
        ],
        alerts: [
          { text: '9 renewals need attention', color: 'var(--color-warning)' }
        ]
      },
      {
        title: 'Contractors',
        icon: 'Briefcase',
        iconColor: 'var(--color-muted-foreground)',
        route: '/maintenance-kanban-workflow-board',
        stats: [
          { label: 'Active Contractors', value: '47' },
          { label: 'Jobs Assigned', value: '28' },
          { label: 'Avg Rating', value: '4.6' }
        ],
        alerts: []
      },
      {
        title: 'Reports',
        icon: 'BarChart3',
        iconColor: 'var(--color-accent)',
        route: '/comprehensive-reports-analytics-dashboard',
        stats: [
          { label: 'Monthly Revenue', value: '£284,500' },
          { label: 'Occupancy Rate', value: '92.7%' },
          { label: 'Compliance Score', value: '96%' }
        ],
        alerts: [
          { text: 'Monthly report ready', color: 'var(--color-success)' }
        ]
      }
    ]);

    setRecentActivities([
      {
        id: 1,
        type: 'certificate',
        description: 'Gas Safety Certificate renewed for 45 Park Avenue',
        user: 'Sarah Johnson',
        timestamp: new Date(Date.now() - 1800000),
        badge: { text: 'Completed', color: 'var(--color-success)' }
      },
      {
        id: 2,
        type: 'maintenance',
        description: 'Emergency plumbing job assigned to ABC Plumbing',
        user: 'Michael Brown',
        timestamp: new Date(Date.now() - 3600000),
        badge: { text: 'Urgent', color: 'var(--color-error)' }
      },
      {
        id: 3,
        type: 'property',
        description: 'New property added: 123 High Street, London',
        user: 'Emma Wilson',
        timestamp: new Date(Date.now() - 7200000),
        badge: { text: 'New', color: 'var(--color-accent)' }
      },
      {
        id: 4,
        type: 'tenancy',
        description: 'Tenancy renewal confirmed for 78 Queen Road',
        user: 'James Taylor',
        timestamp: new Date(Date.now() - 10800000),
        badge: { text: 'Renewed', color: 'var(--color-success)' }
      },
      {
        id: 5,
        type: 'certificate',
        description: 'EPC certificate expiring in 7 days for 12 Oak Street',
        user: 'System Alert',
        timestamp: new Date(Date.now() - 14400000),
        badge: { text: 'Warning', color: 'var(--color-warning)' }
      },
      {
        id: 6,
        type: 'maintenance',
        description: 'Boiler service completed at 56 Elm Avenue',
        user: 'XYZ Heating',
        timestamp: new Date(Date.now() - 18000000),
        badge: { text: 'Completed', color: 'var(--color-success)' }
      },
      {
        id: 7,
        type: 'contractor',
        description: 'New contractor registered: Elite Electricals',
        user: 'Admin',
        timestamp: new Date(Date.now() - 21600000),
        badge: { text: 'New', color: 'var(--color-accent)' }
      },
      {
        id: 8,
        type: 'property',
        description: 'Property inspection scheduled for 34 Maple Drive',
        user: 'Sarah Johnson',
        timestamp: new Date(Date.now() - 25200000),
        badge: null
      }
    ]);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <SessionManager />
      <main className="pt-[108px] px-4 md:px-6 lg:px-8 pb-8">
        <div className="max-w-[1920px] mx-auto">
          <div className="mb-6">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2 font-heading">
              Operations Dashboard
            </h1>
            <p className="text-sm md:text-base text-muted-foreground font-caption">
              Comprehensive overview of your property portfolio and operational status
            </p>
          </div>

          <QuickStatsBar stats={quickStats} />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
            <div className="lg:col-span-2">
              <SmartExpiryRadar variant="summary" />
            </div>
            <div>
              <SystemStatusIndicator />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            {moduleData?.map((module, index) => (
              <ModuleCard
                key={index}
                title={module.title}
                icon={module.icon}
                iconColor={module.iconColor}
                stats={module.stats}
                route={module.route}
                alerts={module.alerts}
              />
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <RecentActivityFeed activities={recentActivities} />
            
            <div className="card">
              <h3 className="text-lg font-semibold text-foreground mb-6 font-heading">Quick Actions</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <button className="p-4 rounded-lg bg-input border border-border transition-smooth hover:border-accent hover:shadow-warm text-left">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-10 w-10 rounded-lg bg-accent/10 flex items-center justify-center">
                      <span className="text-xl">📊</span>
                    </div>
                    <span className="text-sm font-medium text-foreground font-caption">Generate Report</span>
                  </div>
                  <p className="text-xs text-muted-foreground font-caption">Create monthly analytics report</p>
                </button>

                <button className="p-4 rounded-lg bg-input border border-border transition-smooth hover:border-accent hover:shadow-warm text-left">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-10 w-10 rounded-lg bg-success/10 flex items-center justify-center">
                      <span className="text-xl">📧</span>
                    </div>
                    <span className="text-sm font-medium text-foreground font-caption">Send Reminders</span>
                  </div>
                  <p className="text-xs text-muted-foreground font-caption">Bulk certificate expiry alerts</p>
                </button>

                <button className="p-4 rounded-lg bg-input border border-border transition-smooth hover:border-accent hover:shadow-warm text-left">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-10 w-10 rounded-lg bg-warning/10 flex items-center justify-center">
                      <span className="text-xl">📥</span>
                    </div>
                    <span className="text-sm font-medium text-foreground font-caption">Import Data</span>
                  </div>
                  <p className="text-xs text-muted-foreground font-caption">Upload CSV property data</p>
                </button>

                <button className="p-4 rounded-lg bg-input border border-border transition-smooth hover:border-accent hover:shadow-warm text-left">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-10 w-10 rounded-lg bg-error/10 flex items-center justify-center">
                      <span className="text-xl">🔔</span>
                    </div>
                    <span className="text-sm font-medium text-foreground font-caption">View Alerts</span>
                  </div>
                  <p className="text-xs text-muted-foreground font-caption">Check urgent notifications</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <KeyboardShortcutsPanel />
    </div>
  );
};

export default MainOperationsDashboard;